import React from 'react'
import "./css/Footer.css";
import { auth } from "../firebase";
import { useHistory } from 'react-router-dom'

function AdminFooter() {
  const history = useHistory();

  return (
    <div className="footer">
      <div className='footer-link'>
      <div className='footer-links'>
          <a href="/dashboard">Dashboard </a>
          <a href="/products">Products </a>
          <a href="/orders">Orders </a>
        <a href='/admin-login'>Login</a>
          <a href="/upload-product">Upload</a>
          <a href="/customers">Customers</a>
        <a href='/'>Privacy Policy</a>
        <a href='/'>Terms & Conditions</a>
      </div>
      <hr />
    <p>Copyright 2023 <a href='/dashboard'>Product Merche</a>, All Right Reserved</p>
      </div>
    </div>

  )
}

export default AdminFooter
